/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-46de7b2e.js';
import { _ as _slicedToArray } from '../_chunks/dep-e43cf21c.js';
import { _ as _objectWithoutProperties } from '../_chunks/dep-92728dc5.js';
import React, { forwardRef, useState, useMemo, useEffect } from 'react';
import classNames from 'classnames';
import { o as omit_1 } from '../_chunks/dep-7b67cdbf.js';
import noop from '../_util/noop.js';
import useConfig from '../hooks/useConfig.js';
import useControlled from '../hooks/useControlled.js';
import { Select } from '../select/index.js';
import { InputNumber } from '../input-number/index.js';
import '../input-adornment/index.js';
import { useLocaleReceiver } from '../locale/LocalReceiver.js';
import useBoundaryJumper from './hooks/useBoundaryJumper.js';
import usePrevNextJumper from './hooks/usePrevNextJumper.js';
import usePageNumber from './hooks/usePageNumber.js';
import useTotal from './hooks/useTotal.js';
import { pageSizeValidator } from './validators.js';
import { paginationDefaultProps } from './defaultProps.js';
import InputAdornment from '../input-adornment/InputAdornment.js';
import '../_chunks/dep-2acfafca.js';
import '../_chunks/dep-c3f1141e.js';
import '../_chunks/dep-33ffecad.js';
import '../_chunks/dep-4941ebe7.js';
import '../_chunks/dep-e9b62d1f.js';
import '../_chunks/dep-77e34309.js';
import '../_chunks/dep-c1f93350.js';
import '../_chunks/dep-7dce2c26.js';
import '../_chunks/dep-09050977.js';
import '../_chunks/dep-4b8f240e.js';
import '../_chunks/dep-9acbc163.js';
import '../_chunks/dep-7b52f080.js';
import '../_chunks/dep-f10515e8.js';
import '../_chunks/dep-88cd50bf.js';
import '../_chunks/dep-dcb5aa2a.js';
import '../_chunks/dep-ee4bf8c2.js';
import '../_chunks/dep-934eda0c.js';
import '../_chunks/dep-12510d64.js';
import '../_chunks/dep-6b568d83.js';
import '../_chunks/dep-304e657b.js';
import '../_chunks/dep-6506fbc2.js';
import '../_chunks/dep-23d0a0bb.js';
import '../_chunks/dep-c8399d32.js';
import '../_chunks/dep-ca64038e.js';
import '../_chunks/dep-c00532d4.js';
import '../_chunks/dep-f4a320cd.js';
import '../_chunks/dep-e73d1b75.js';
import '../_chunks/dep-e285f2f8.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-d71ee5f3.js';
import '../_chunks/dep-bb5d7b1e.js';
import '../_chunks/dep-ec70b95c.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../_chunks/dep-cbcc9f89.js';
import '../_common/js/global-config/default-config.js';
import '../_chunks/dep-f721d103.js';
import '../_chunks/dep-4559db64.js';
import '../select/base/Select.js';
import '../_chunks/dep-337b4140.js';
import '../_util/forwardRefWithStatics.js';
import 'hoist-non-react-statics';
import '../select/util/helper.js';
import '../_chunks/dep-fd3498b6.js';
import '../select/base/OptionGroup.js';
import '../select/defaultProps.js';
import '../select/base/Option.js';
import '../_chunks/dep-0e15088f.js';
import '../_chunks/dep-6c5254c6.js';
import '../hooks/useDomRefCallback.js';
import '../_util/useRipple.js';
import '../_util/useAnimation.js';
import '../_util/setStyle.js';
import '../_util/dom.js';
import 'raf';
import '../_util/easing.js';
import '../common/FakeArrow.js';
import '../loading/index.js';
import '../loading/Loading.js';
import '../common/Portal.js';
import 'react-dom';
import '../loading/gradient.js';
import '../_common/js/loading/circle-adapter.js';
import '../_common/js/utils/set-style.js';
import '../_common/js/utils/helper.js';
import '../_chunks/dep-ec16db36.js';
import '../_chunks/dep-036ad2cc.js';
import '../loading/defaultProps.js';
import '../loading/plugin.js';
import '../_util/react-render.js';
import '../_chunks/dep-e0370ebe.js';
import '../loading/style/css.js';
import '../loading/type.js';
import '../select-input/index.js';
import '../select-input/SelectInput.js';
import '../popup/index.js';
import '../popup/Popup.js';
import 'react-transition-group';
import 'react-popper';
import '../hooks/usePrevious.js';
import '../popup/hooks/useTrigger.js';
import 'react-is';
import '../popup/utils/ref.js';
import '../_util/composeRefs.js';
import '../popup/utils/transition.js';
import '../_util/useMutationObserver.js';
import '../_chunks/dep-01ce608f.js';
import '../_chunks/dep-77a54538.js';
import '../_util/useWindowSize.js';
import '../popup/defaultProps.js';
import '../popup/style/css.js';
import '../popup/type.js';
import '../select-input/useSingle.js';
import '../_chunks/dep-4f1e1217.js';
import '../_chunks/dep-29cb89ad.js';
import '../input/index.js';
import '../input/Input.js';
import 'tdesign-icons-react';
import '../_util/useLayoutEffect.js';
import '../hooks/useGlobalIcon.js';
import '../input/InputGroup.js';
import '../input/defaultProps.js';
import '../_util/parseTNode.js';
import '../input/useLengthLimit.js';
import '../_common/js/log/index.js';
import '../_common/js/log/log.js';
import '../config-provider/index.js';
import '../config-provider/ConfigProvider.js';
import '../input/style/css.js';
import '../input/type.js';
import '../select-input/useMultiple.js';
import '../tag-input/index.js';
import '../tag-input/TagInput.js';
import '../_util/useDragSorter.js';
import '../tag-input/useTagScroll.js';
import '../tag-input/useTagList.js';
import '../tag/index.js';
import '../tag/Tag.js';
import '../tag/CheckTag.js';
import '../tag/defaultProps.js';
import '../tag/style/css.js';
import '../tag/type.js';
import '../tag-input/useHover.js';
import '../tag-input/defaultProps.js';
import '../tag-input/style/css.js';
import '../tag-input/type.js';
import '../select-input/useOverlayInnerStyle.js';
import '../select-input/defaultProps.js';
import '../select-input/style/css.js';
import '../select-input/type.js';
import '../select/base/PopupContent.js';
import '../select/hooks/usePanelVirtualScroll.js';
import '../hooks/useVirtualScroll.js';
import '../hooks/useResizeObserver.js';
import '../select/hooks/useOptions.js';
import '../select/style/css.js';
import '../select/type.js';
import '../input-number/InputNumber.js';
import '../button/index.js';
import '../button/Button.js';
import '../button/defaultProps.js';
import '../button/style/css.js';
import '../button/type.js';
import '../input-number/useInputNumber.js';
import '../_util/useCommonClassName.js';
import '../_common/js/input-number/number.js';
import '../_chunks/dep-a827ffec.js';
import '../_common/js/input-number/large-number.js';
import '../input-number/defaultProps.js';
import '../input-number/style/css.js';
import '../input-number/type.js';
import '../input-adornment/style/css.js';
import '../input-adornment/type.js';

var _excluded = ["theme", "size", "total", "showPageSize", "showPageNumber", "showPreviousAndNextBtn", "showFirstAndLastPageBtn", "showJumper", "pageEllipsisMode", "disabled", "foldedMaxPageBtn", "maxPageBtn", "totalContent", "pageSizeOptions", "onChange", "onCurrentChange", "onPageSizeChange", "style", "className", "selectProps"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Option = Select.Option;
var Pagination = /*#__PURE__*/forwardRef(function (props, ref) {
  var _classNames;
  var theme = props.theme,
    size = props.size,
    total = props.total,
    showPageSize = props.showPageSize,
    showPageNumber = props.showPageNumber,
    showPreviousAndNextBtn = props.showPreviousAndNextBtn,
    showFirstAndLastPageBtn = props.showFirstAndLastPageBtn,
    showJumper = props.showJumper,
    pageEllipsisMode = props.pageEllipsisMode,
    disabled = props.disabled,
    foldedMaxPageBtn = props.foldedMaxPageBtn,
    maxPageBtn = props.maxPageBtn,
    totalContent = props.totalContent,
    pageSizeOptions = props.pageSizeOptions,
    _props$onChange = props.onChange,
    onChange = _props$onChange === void 0 ? noop : _props$onChange,
    onCurrentChange = props.onCurrentChange,
    onPageSizeChange = props.onPageSizeChange,
    style = props.style,
    className = props.className,
    selectProps = props.selectProps,
    otherProps = _objectWithoutProperties(props, _excluded);
  var restProps = omit_1(otherProps, ["current", "pageSize", "defaultPageSize", "defaultCurrent"]);
  var _useLocaleReceiver = useLocaleReceiver("pagination"),
    _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 2),
    locale = _useLocaleReceiver2[0],
    t = _useLocaleReceiver2[1];
  var _useControlled = useControlled(props, "pageSize", onPageSizeChange),
    _useControlled2 = _slicedToArray(_useControlled, 2),
    pageSize = _useControlled2[0],
    setPageSize = _useControlled2[1];
  var _useControlled3 = useControlled(props, "current", onCurrentChange),
    _useControlled4 = _slicedToArray(_useControlled3, 2),
    current = _useControlled4[0],
    setCurrent = _useControlled4[1];
  var _useState = useState(current),
    _useState2 = _slicedToArray(_useState, 2),
    jumpValue = _useState2[0],
    setJumpValue = _useState2[1];
  var min = 1;
  var _useConfig = useConfig(),
    classPrefix = _useConfig.classPrefix;
  var name = "".concat(classPrefix, "-pagination");
  var pageCount = useMemo(function () {
    var calCount = Math.ceil(total / pageSize);
    return calCount > 0 ? calCount : 1;
  }, [pageSize, total]);
  var changeCurrent = function changeCurrent(_nextCurrent, _nextPageSize) {
    if (disabled || current === _nextCurrent) return;
    var nextCurrent = _nextCurrent;
    var nextPageSize = _nextPageSize;
    if (!nextPageSize && !pageSizeValidator(nextPageSize)) {
      var _pageSizeOptions$;
      nextPageSize = pageSize !== null && pageSize !== void 0 ? pageSize : typeof pageSizeOptions[0] === "number" ? pageSizeOptions[0] : (_pageSizeOptions$ = pageSizeOptions[0]) === null || _pageSizeOptions$ === void 0 ? void 0 : _pageSizeOptions$.value;
    }
    if (nextCurrent < min) nextCurrent = min;
    if (nextCurrent > pageCount) nextCurrent = pageCount;
    setCurrent(nextCurrent, {
      current: nextCurrent,
      previous: current,
      pageSize: nextPageSize
    });
    onChange({
      current: nextCurrent,
      previous: current,
      pageSize: nextPageSize
    });
  };
  var changePageSize = function changePageSize(nextPageSize) {
    var nextCurrent = Math.min(current, Math.ceil(total / nextPageSize));
    var pageInfo = {
      current: nextCurrent,
      previous: current,
      pageSize: nextPageSize
    };
    setPageSize(nextPageSize, pageInfo);
    if (current !== nextCurrent) {
      changeCurrent(nextCurrent, nextPageSize);
    } else {
      onChange(pageInfo);
    }
  };
  var _useTotal = useTotal({
      totalContent: totalContent,
      pageSize: pageSize,
      current: current,
      total: total
    }),
    totalContrl = _useTotal.totalContrl;
  var _useBoundaryJumper = useBoundaryJumper({
      disabled: disabled,
      current: current,
      pageCount: pageCount,
      showFirstAndLastPageBtn: showFirstAndLastPageBtn,
      changeCurrent: changeCurrent
    }),
    firstPageJumper = _useBoundaryJumper.firstPageJumper,
    lastPageJumper = _useBoundaryJumper.lastPageJumper;
  var _usePrevNextJumper = usePrevNextJumper({
      disabled: disabled,
      current: current,
      pageCount: pageCount,
      showPreviousAndNextBtn: showPreviousAndNextBtn,
      changeCurrent: changeCurrent
    }),
    prevJumper = _usePrevNextJumper.prevJumper,
    nextJumper = _usePrevNextJumper.nextJumper;
  var _usePageNumber = usePageNumber({
      showPageNumber: showPageNumber,
      maxPageBtn: maxPageBtn,
      disabled: disabled,
      current: current,
      pageCount: pageCount,
      foldedMaxPageBtn: foldedMaxPageBtn,
      changeCurrent: changeCurrent,
      pageEllipsisMode: pageEllipsisMode
    }),
    pageNumberContrl = _usePageNumber.pageNumberContrl;
  useEffect(function () {
    setJumpValue(current);
  }, [current]);
  var pageSizeContrl = showPageSize && pageSizeOptions.length ? /* @__PURE__ */React.createElement("div", {
    className: "".concat(name, "__select")
  }, /* @__PURE__ */React.createElement(Select, _objectSpread({
    autoWidth: true,
    size: size,
    value: pageSize,
    disabled: disabled,
    onChange: changePageSize
  }, selectProps), pageSizeOptions.map(function (item) {
    return typeof item === "number" ? /* @__PURE__ */React.createElement(Option, {
      key: item,
      label: t(locale.itemsPerPage, {
        size: item
      }),
      value: item
    }) : /* @__PURE__ */React.createElement(Option, {
      key: item.value,
      label: item.label,
      value: item.value
    });
  }))) : null;
  var Jumper = /* @__PURE__ */React.createElement("div", {
    className: "".concat(name, "__jump")
  }, t(locale.jumpTo), /* @__PURE__ */React.createElement(InputAdornment, {
    append: "/ ".concat(pageCount, " ").concat(t(locale.page))
  }, /* @__PURE__ */React.createElement(InputNumber, {
    className: "".concat(classPrefix, "-pagination__input"),
    min: min,
    size: size,
    theme: "normal",
    max: pageCount,
    disabled: disabled,
    value: jumpValue,
    onChange: function onChange(val) {
      return setJumpValue(val);
    },
    onBlur: function onBlur(val) {
      return changeCurrent(val);
    },
    onEnter: function onEnter(val) {
      return changeCurrent(val);
    },
    placeholder: ""
  })));
  return /* @__PURE__ */React.createElement("div", _objectSpread({
    className: classNames(name, className, (_classNames = {}, _defineProperty(_classNames, "".concat(classPrefix, "-size-s"), size === "small"), _defineProperty(_classNames, "".concat(classPrefix, "-is-disabled"), disabled), _classNames)),
    style: style,
    ref: ref
  }, restProps), totalContrl, pageSizeContrl, firstPageJumper, prevJumper, theme === "default" && pageNumberContrl, theme === "simple" && Jumper, nextJumper, lastPageJumper, theme === "default" && showJumper && Jumper);
});
Pagination.displayName = "Pagination";
Pagination.defaultProps = paginationDefaultProps;

export { Pagination as default };
//# sourceMappingURL=Pagination.js.map
